import config from '../common/config'
import VideoTransport from '../transports/common/video-transport'

// Rewrite a media URL to the same-origin /media proxy path (uses basePath, not assetPrefix).
export const getMediaProxyUrl = (url: string): string => {
    if (!url) {
        return url
    }
    try {
        const { pathname, search } = new URL(url)
        return `${config.basePath}/media${pathname}${search}`
    } catch {
        return url
    }
}

// Proxy both the video URL and its thumbnail at the transport source.
export const getProxiedVideoTransport = (video?: VideoTransport | null): VideoTransport | undefined => {
    if (!video) {
        return undefined
    }
    return {
        url: getMediaProxyUrl(video.url),
        thumbnailUrl: getMediaProxyUrl(video.thumbnailUrl),
    }
}
